import React, { useState, useEffect } from 'react';


import './postAd.css';
import { useNavigate, Link } from "react-router";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';


import { IoLayersOutline } from "react-icons/io5";
import { IoCheckmarkSharp } from "react-icons/io5";

import { HiOutlineArrowLongRight } from "react-icons/hi2";


import Form from 'react-bootstrap/Form';
import Swal from 'sweetalert2'


import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import AccountSidebar from '../../components/sidebar/accountSidebar';
import TagInput from '../../components/property/tagInput';

import {connect} from 'react-redux';
import * as actions from  '../../store/postData/actions';


const PostAd2 = ({ postAdData, postAd, setPostAdsStep2Data, postAdData2, props }) => {  

    const navigate = useNavigate(); 
    const [ formData, setFormData ] = useState(postAdData.propertyAttributes);
    const [ attributesValues, setAttributesValues ] = useState(postAdData.propertyAttributesValues);
    const [ errors, setErrors ] = useState('');
    const [prevStepFormData, setPrevStepFormData ] = useState(postAdData.formData);
    
    const [tags, setTags] = useState([]);


    const goToStepOne = () => {
        setPostAdsStep2Data({formData});
        navigate(`/post-Ad/step1`);
    }

    const setAnimities = (aimities) => {
        setTags(aimities);
        setFormData((prevState) => ({
            ...prevState,
            other_amenities: aimities,
        }));
    }

    useEffect(() => { 
        // console.log('hi', postAdData2)
        if(!postAdData){
            navigate(`/post-Ad/step1`);
        }
    },[postAdData]);

    useEffect(() => { 
        // console.log('hi', postAdData2)
        if(postAdData2 && postAdData2.formData  ){
            setFormData(postAdData2.formData);
        }
    },[postAdData2]);

    // console.log('postAdData2', postAdData2)
    useEffect(() => {
        
		if(postAdData){
            
            if(prevStepFormData.property_list_type == 'rent'){
                setFormData((prevState) => ({
                    ...prevState,
                    is_rent: 1,
                }));
            } else {
                setFormData((prevState) => ({
                    ...prevState,
                    is_sale: 1,
                }));
            }
		}
	},[]);


    // Handle input changes dynamically
    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setFormData((prevState) => ({
        ...prevState,
        [name]: value,
        }));
        
        // Validate field when user types
        validateField(name, value);
    };

    const handleChangeCheckbox = (e) => { 
        const { name, checked } = e.target;
        
        setFormData((prevState) => ({
            ...prevState,
            [name]: checked ? 1 : 0, // Update checkbox state
        }));
        // Validate field when user types
        validateField(name, checked);
    }

    // Validation function
    const validateField = (name, value) => { 
        const matchedAttribute = attributesValues.find(attr => attr.attribute_code === name);
        
        if(matchedAttribute.is_required){
            let errorMsg = "";

            if (!value) {
                errorMsg = `${name.replace(/_/g, " ")} is required`;
            }

            setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMsg,
            }));
        }
    };

  

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        let isValid = true;
        let newErrors = {};

        // Validate all fields
        Object.keys(formData).forEach((key) => {
        if (!formData[key]) {
            const matchedAttribute = attributesValues.find(attr => attr.attribute_code === key);
            
            if(matchedAttribute.is_required){
                newErrors[key] = `${key.replace(/_/g, " ")} is required`;
                isValid = false;
            }
        }
        });

        setErrors(newErrors);
        // console.log(isValid, newErrors, formData, prevStepFormData);
        if (isValid) {
            let postAddData = '';
            const mergedObject = Object.assign({}, formData, prevStepFormData);
            if(postAdData.propertyImages && postAdData.propertyImages.length>0){
                const mergedPropertyObject = Object.assign({}, {propertiesImages: postAdData.propertyImages}, mergedObject ); 
                postAddData = Object.assign({}, {token: localStorage.getItem('user')}, mergedPropertyObject ) 
            } else {
                postAddData = Object.assign({}, {token: localStorage.getItem('user')}, mergedObject )
            }
            postAd(postAddData).then(res => {
                if(res.payload.response && res.payload.response.status == 422){
                    // console.log(res.payload.response.data.message[0].message)
                    Swal.fire({
                        title: res.payload.response.statusText,
                        text: res.payload.response.data.message[0].message,
                        icon: 'error',
                        confirmButtonText: 'Ok'
                      })
                } else {
                    navigate('/post-ad/success')
                }
            });            
        }
    };


    const renderFormFields = (item) => {
        if(item.frontend_input == 'input_box'){
           return renderInputBox(item);
        } else if(item.frontend_input == 'select'){
            return renderSelectBox(item);
        } else if(item.frontend_input == "radio_button"){
            return renderCheckBox(item);
        } else if(item.frontend_input == "checkbox"){
            return renderCheckBox(item);
        } else if(item.frontend_input == 'text'){
            return renderTextArea(item)
        } else if(item.frontend_input == 'boolean'){
            return renderCheckBox(item)
        }
    }

    const renderSelectBox = (item) => {
        // console.log(item.select_options)
        if(item.select_options != null){
            const options = item.select_options.split(",");
            return <Col className='mb-3' md={6} key={`attributefield${item.attribute_id}`}>
                    <Form.Group className="form-group" controlId="formGridEmail" >
                        <Form.Label>{item.frontend_label}:</Form.Label>
                        <Form.Select aria-label="Default select example" name={item.attribute_code} defaultValue={postAdData2 && postAdData2.formData &&  postAdData2.formData[item.attribute_code] ? postAdData2.formData[item.attribute_code] : ''} onChange={handleChange}>
                            <option selected="selected">Choose</option>
                            {
                                options.map((optionVlaue, index) => {
                                    return <option value={optionVlaue} key={`${item.attribute_code}-${index}`}>{optionVlaue}</option>
                                })
                            }
                        </Form.Select>
                    </Form.Group>
                    </Col>
        } else {
            <Col className='mb-3' md={6}><Form.Group className="form-group" controlId="formGridEmail">
                <Form.Label>{item.frontend_label}:</Form.Label>
                <Form.Select aria-label="Default select example" onChange={handleChange} name={item.attribute_code} className={errors[item.attribute_code] ? 'input-error' : ''}>
                    <option>Choose</option>
                    
                </Form.Select>
            </Form.Group>
            </Col>
        }
    }

    const renderCheckBox = (item) => {
        // console.log(postAdData.formData.property_list_type)
        return (item.attribute_code == 'is_pre_leased_property' && postAdData.formData.property_list_type == 'sale') ?
                <Col className='mb-3' md={6} key={`attributefield${item.attribute_id}`}>
                    <Form.Group className="form-group align-items-bottom" controlId="formGridPassword">
                        <Form.Label>{item.frontend_label}</Form.Label>
                        <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            label={formData[item.attribute_code] ? 'Yes' : 'No'} 
                            name={item.attribute_code} 
                            onChange={handleChangeCheckbox} 
                            checked={formData[item.attribute_code]}
                            className={errors[item.attribute_code] ? 'input-error' : ''}
                        />
                    </Form.Group>
                </Col>
            : item.attribute_code != 'is_pre_leased_property' ?
                <Col className='mb-3' md={6} key={`attributefield${item.attribute_id}`}>
                    <Form.Group className="form-group align-items-bottom" controlId="formGridPassword">
                        <Form.Label>{item.frontend_label}</Form.Label>
                        <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            label={formData[item.attribute_code] ? 'Yes' : 'No'} 
                            name={item.attribute_code} 
                            onChange={handleChangeCheckbox} 
                            checked={formData[item.attribute_code]}
                            className={errors[item.attribute_code] ? 'input-error' : ''}
                        />
                    </Form.Group>
                </Col>
            : null
            
    }

    const renderInputBox = (item) => {
        if(item.attribute_code == 'other_amenities'){
            return <Col className='mb-3' md={12} key={`attributefield${item.attribute_id}`}>
                <Form.Label>{item.frontend_label}</Form.Label>
                <TagInput tags={tags} setAnimities={setAnimities} />
            </Col>
        } else {
            return (formData.is_pre_leased_property == true && item.attribute_code == 'is_pre_leased_property_rent' && postAdData.formData.property_list_type == 'sale') ? 
                <Col className='mb-3' md={6} key={`attributefield${item.attribute_id}`}>
                    <Form.Group  className="form-group"  controlId="formGroupLocation">
                        <Form.Label>{item.frontend_label}</Form.Label>
                        <Form.Control type="text" placeholder={item.frontend_label} name={item.attribute_code}
                            className={errors[item.attribute_code] ? 'input-error' : ''}
                            onChange={handleChange} 
                            // className={ errors.location ? "input-error mb-3" : "mb-3"}
                        />
                    </Form.Group> 
                </Col>
                : item.attribute_code != 'is_pre_leased_property_rent' ? 
                    <Col className='mb-3' md={6} key={`attributefield${item.attribute_id}`}>
                        <Form.Group  className="form-group"  controlId="formGroupLocation">
                            <Form.Label>{item.frontend_label} </Form.Label>
                            <Form.Control type="text" placeholder={item.frontend_label} name={item.attribute_code}
                                className={errors[item.attribute_code] ? 'input-error' : ''}
                                onChange={handleChange} 
                                defaultValue={postAdData2 && postAdData2.formData &&  postAdData2.formData[item.attribute_code] ? postAdData2.formData[item.attribute_code] : ''}
                            />
                        </Form.Group> 
                    </Col>
                : null
        }
        
        // is_pre_leased_property_price // is_pre_lease_property_rent
    }

    const renderTextArea = (item) => {
        return <Col md={12} className='mb-3' key={`attributefield${item.attribute_id}`}>
                    <Form.Group as={Col} controlId="formGridEmail">
                        <Form.Label>Description of property: </Form.Label>
                        <Form.Control  name={item.attribute_code}
                            as="textarea"
                            placeholder={item.frontend_label}
                            style={{ height: '100px' }} 
                            onChange={handleChange} 
                            className={errors[item.attribute_code] ? 'input-error' : ''} 
                            defaultValue={postAdData2 && postAdData2.formData &&  postAdData2.formData[item.attribute_code] ? postAdData2.formData[item.attribute_code] : ''}
                            />
                    </Form.Group>
                </Col>
    }

    if(postAdData){
    return (
        <div>
            <Header/>            

            <section className='pt-5 pb-5'>
                <Container>
                    <Row className='justify-content-center'>
                        <AccountSidebar />
                        <Col lg={9}>
                            <div className="card shadow">
                                <div>
                                    <ul className='d-flex flex-row process_tab w-100 m-0 p-0 justify-content-'>
                                        <li className='inactive'>
                                            <a href='#' onClick={() => goToStepOne()} className='d-flex align-items-center'>
                                                <i>
                                                    <span className='layer'><IoLayersOutline /></span>
                                                    <span className='check'><IoCheckmarkSharp /></span>
                                                </i>
                                                <div>
                                                    <div>Steps 01</div>
                                                    <p className='mb-0'>Ads Information</p>
                                                </div>
                                            </a>
                                        </li>
                                        <li className='active'>
                                            <a href='#' className='d-flex align-items-center'>
                                                <i>
                                                    <span className='layer'><IoLayersOutline /></span>
                                                    <span className='check'><IoCheckmarkSharp /></span>
                                                </i>
                                                <div>
                                                    <div>Steps 02</div>
                                                    <p className='mb-0'>Property Details </p>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <form className='p-4 grid-form' onSubmit={handleSubmit}>
                                    <Row>
                                    {
                                        Object.keys(formData).map((field, index) => (
                                            attributesValues[index].display_on_frontent ?                                                 
                                                renderFormFields(attributesValues[index])
                                            : ''
                                        ))
                                    }
                                    </Row>
                                    <Row className="mb-3 mt-4">
                                        <div>
                                            <Button variant="light" size="lg">View posting rules</Button>
                                            <Button type="submit" variant="info" size="lg" className="ms-3">Next Steps <HiOutlineArrowLongRight /></Button>
                                        </div>
                                    </Row>
                                </form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            
            <Footer/>
        </div>
    )
} else {
    return null;
}
}
function mapStateToProps(state) {
    return {
      postAdData: state.postData.postAdData,
      postAdData2: state.postData && state.postData.postAdData2 ? state.postData.postAdData2 : ''
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        postAd: (post) => dispatch(actions.postAd(post)),
        setPostAdsStep2Data: (post) => dispatch(actions.setPostAdsStep2Data(post)),
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(PostAd2);